import { type PrRow, api } from '../lib/api.js';
import { el, mount } from '../lib/dom.js';
import { formatDay } from '../lib/format.js';
import { renderNav } from './nav.js';

export async function renderPrs() {
  const { prs } = await api.get<{ prs: PrRow[] }>('/prs');

  const byMuscle = new Map<string, PrRow[]>();
  for (const p of prs) {
    const arr = byMuscle.get(p.muscle_group) ?? [];
    arr.push(p);
    byMuscle.set(p.muscle_group, arr);
  }

  const groups = [...byMuscle.entries()].map(([muscle, list]) =>
    el('section', { style: 'margin-bottom: var(--space-5)' }, [
      el('h2', { class: 'field__label', style: 'margin-bottom: var(--space-2)' }, [muscle]),
      el(
        'ul',
        { class: 'stack stack--sm' },
        list.map((p) =>
          el('li', { class: 'card row row--between' }, [
            el('div', {}, [
              el('div', { style: 'font-weight: 600' }, [p.name]),
              el('div', { class: 'dim', style: 'font-size: var(--text-sm)' }, [
                formatDay(p.achieved_at),
              ]),
            ]),
            el('div', { class: 'pill pill--accent', style: 'font-variant-numeric: tabular-nums' }, [
              `${p.weight_kg}kg × ${p.reps}`,
            ]),
          ]),
        ),
      ),
    ]),
  );

  mount(
    el('main', { class: 'view' }, [
      el('h1', { class: 'h1', style: 'margin-bottom: var(--space-5)' }, ['Recordes (PRs)']),
      prs.length
        ? el('div', {}, groups)
        : el('p', { class: 'dim' }, ['Sem PRs ainda. Loga um treino completo!']),
      renderNav('prs'),
    ]),
  );
}
